// src/components/sections/OpportunityLinks.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { 
  Box, 
  Typography, 
  Button
} from '@mui/material';
import TeamsIcon from '@mui/icons-material/People';
import SummaryIcon from '@mui/icons-material/Description';
import ContractIcon from '@mui/icons-material/RequestQuote';

/**
 * OpportunityLinks component displays links to important opportunity resources
 */
const OpportunityLinks = ({ 
  opportunityId,
  teamsUrl,
  summaryUrl,
  sowUrl,
  hasSow = false
}) => {
  return (
    <Box sx={{ px: 1.5, pt: 1, pb: 1 }}>
      <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, mb: 1 }}>
        OPPORTUNITY RESOURCES
      </Typography>
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<TeamsIcon fontSize="small" />}
          sx={{
            fontSize: '0.65rem',
            borderRadius: 1,
            color: '#64B5F6',
            borderColor: 'rgba(100, 181, 246, 0.3)',
            flex: 1,
            textTransform: 'none'
          }}
        >
          MS Teams Site
        </Button>
        
        <Button
          variant="outlined"
          size="small"
          startIcon={<SummaryIcon fontSize="small" />}
          sx={{
            fontSize: '0.65rem',
            borderRadius: 1,
            color: '#BB86FC',
            borderColor: 'rgba(187, 134, 252, 0.3)',
            flex: 1,
            textTransform: 'none'
          }}
        >
          Opportunity Summary
        </Button>
        
        <Button
          variant="outlined"
          size="small"
          startIcon={<ContractIcon fontSize="small" />}
          sx={{
            fontSize: '0.65rem',
            borderRadius: 1,
            color: '#03DAC6',
            borderColor: 'rgba(3, 218, 198, 0.3)',
            flex: 1,
            textTransform: 'none'
          }}
        >
          Statement of Work
        </Button>
      </Box>
    </Box>
  );
};

OpportunityLinks.propTypes = {
  opportunityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  teamsUrl: PropTypes.string,
  summaryUrl: PropTypes.string,
  sowUrl: PropTypes.string,
  hasSow: PropTypes.bool
};

export default OpportunityLinks;
